import sumBy from 'lodash/sumBy'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function useCheckoutSummary(
  dueNowData,
  selectedTrip,
  shopInfo,
  roomParams,
  checkoutInclusions,
) {
  const {
    kind,
    slug,
    countrySlug,
    title,
    productImage,
    countryTitleIn,
  } = shopInfo
  const [cabinOverview, setCabinOverview] = useState([])
  const guestsSplitting = useSelector(({ guestsSplitting }) => guestsSplitting)

  useEffect(() => {
    setCabinOverview(
      guestsSplitting.reduce((cabins, rawCabin) => {
        const room = selectedTrip?.packages?.find(
          (el) => el.roomCategory.id === rawCabin?.id,
        )
        const { cart, title } = rawCabin
        const cabin = cart.map((item) => {
          return {
            title,
            cabinPrice: item.reduce((acc, el) => acc + el.priceNet * el.qty, 0),
            cabinComparePrice: item.reduce((acc, el) => acc + el.priceGross * el.qty, 0),
            items: item,
            room,
          }
        })
        return [...cabins, ...cabin]
      }, []),
    )
  }, [guestsSplitting])

  const checkoutSummary = {
    shopTitle: title,
    shopKind: kind,
    shopLocationSlug: countrySlug,
    shopLocationTitle: countryTitleIn,
    shopSlug: slug,
    numberOfReviews: 0,
    pax: roomParams.totalGuests,
    rate: null,
    thumbnails: {
      DOSliderMobileLand: productImage,
    },
    dateFrom: selectedTrip.dateFrom,
    dateTo: selectedTrip.dateTo,
    duration: selectedTrip.duration,
    totalNumberOfDives: selectedTrip?.itinerary?.totalNumberOfDives,
    totalNumberOfDivesMax: selectedTrip?.itinerary?.totalNumberOfDivesMax,
    insurances: selectedTrip.insurances,
    itemsIncluded: checkoutInclusions,
    cabinOverview,
    ...dueNowData,
  }

  return {
    checkoutSummary,
  }
}
